import { createSlice } from '@reduxjs/toolkit';
import {getNationalitiesAsync} from './Actions';

export interface NationalitiesValues {
  value: string; 
  label: string; 
}

export interface NationalitiesState {
  status: 'idle' | 'loading' | 'failed';
  list: Array<NationalitiesValues>;
  errorMessage: string | undefined;
}

const initialState: NationalitiesState = {
  status: 'idle',
  list: [],
  errorMessage: '',
};


export const nationalitiesSlice = createSlice({
  name: 'nationalities',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNationalitiesAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getNationalitiesAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.list = [];
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(getNationalitiesAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
        state.errorMessage = ''
      })
  },
});

export default nationalitiesSlice.reducer;
